import React from "react"
import t from "frontend/utils/translations"

const EmbeddedSlideshow = ({ embedUrl }) => {
  return (
    <iframe
      id="upload_preview"
      frameBorder="0"
      width="100%"
      aria-label={t("upload.form.preview_label")}
      height="100%"
      style={{ backgroundColor: "rgb(245, 245, 245)" }}
      src={`${embedUrl}?hostedIn=slideshare&amp;uploadpreview=1&amp;autoplay=0`}
    />
  )
}

export default EmbeddedSlideshow
